import React, { Fragment, useCallback } from 'react'
import IconButton from '@material-ui/core/IconButton'
import { MoreVert } from '@material-ui/icons'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { makeStyles } from '@material-ui/core'
import { IMoreBtnMenu } from 'src/models'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/react-hooks'

import { HandleCompanyUsersRole, GetCompanyUsersRoles } from 'store'
import styles from './styles'
import { EnumUserRoles } from 'utils'

const useStyles = makeStyles(styles)

const MoreBtnMenu: React.FunctionComponent<IMoreBtnMenu> = ({
	handleActionClick,
	handleMenuClick,
	handleClose,
	anchorEl,
	userId = '',
	roleType,
	companyId,
	companyRoleId,
	companyRolesIds,
}) => {
	const openMenu = Boolean(anchorEl)
	const classes = useStyles()
	const { t } = useTranslation()

	const [handleUsersCompanyRoleMutation] = useMutation(
		HandleCompanyUsersRole,
		{
			update(cache, { data: { handleCompanyUsersRole } }) {
				const query = GetCompanyUsersRoles
				try {
					cache.writeQuery({
						query,
						data: {
							getCompanyUsersRoles: handleCompanyUsersRole,
						},
						variables: {
							companyId,
						},
					})
					return null
				} catch (e) {
					console.error(e)
				}
			},
		},
	)

	const handleMoveToAnotherRole = useCallback(
		(roleType: EnumUserRoles, companyRoleId: string) => {
			handleClose()
			handleUsersCompanyRoleMutation({
				variables: {
					data: {
						id: companyRoleId,
						usersId: [userId],
						role: roleType,
						companyId: companyId,
					},
				},
			})
		},
		[companyId, userId, handleUsersCompanyRoleMutation, handleClose],
	)

	return (
		<Fragment>
			<IconButton
				id={'menu'}
				aria-owns={openMenu ? 'menu' : undefined}
				aria-label="More"
				aria-haspopup="true"
				onClick={handleMenuClick}
				classes={{
					root: classes.moreVertButton,
				}}
			>
				<MoreVert className={classes.moreVertIcon} />
			</IconButton>
			<Menu
				id={'menu'}
				anchorEl={anchorEl}
				open={openMenu}
				onClose={handleClose}
				classes={{
					paper: classes.moreMenu,
				}}
				PaperProps={{
					style: {
						width: 'auto',
					},
				}}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				getContentAnchorEl={null}
			>
				{
					<MenuItem onClick={() => handleActionClick(userId)}>
						{t('Delete')}
					</MenuItem>
				}
				{roleType !== EnumUserRoles.COMPANY_ADMIN && (
					<MenuItem
						onClick={() =>
							handleMoveToAnotherRole(
								EnumUserRoles.COMPANY_ADMIN,
								(companyRoleId =
									companyRolesIds[
										EnumUserRoles.COMPANY_ADMIN
									]),
							)
						}
					>
						{t('Move to Administrator')}
					</MenuItem>
				)}
				{roleType !== EnumUserRoles.COMPANY_MANAGER && (
					<MenuItem
						onClick={() =>
							handleMoveToAnotherRole(
								EnumUserRoles.COMPANY_MANAGER,
								(companyRoleId =
									companyRolesIds[
										EnumUserRoles.COMPANY_MANAGER
									]),
							)
						}
					>
						{t('Move to Manager')}
					</MenuItem>
				)}
				{roleType !== EnumUserRoles.JOB_PUBLISHER && (
					<MenuItem
						onClick={() =>
							handleMoveToAnotherRole(
								EnumUserRoles.JOB_PUBLISHER,
								(companyRoleId =
									companyRolesIds[
										EnumUserRoles.JOB_PUBLISHER
									]),
							)
						}
					>
						{t('Move to Job publisher')}
					</MenuItem>
				)}
				{roleType !== EnumUserRoles.MODERATOR && (
					<MenuItem
						onClick={() =>
							handleMoveToAnotherRole(
								EnumUserRoles.MODERATOR,
								(companyRoleId =
									companyRolesIds[EnumUserRoles.MODERATOR]),
							)
						}
					>
						{t('Move to Moderator')}
					</MenuItem>
				)}
				{roleType !== EnumUserRoles.PUBLISHER && (
					<MenuItem
						onClick={() =>
							handleMoveToAnotherRole(
								EnumUserRoles.PUBLISHER,
								(companyRoleId =
									companyRolesIds[EnumUserRoles.PUBLISHER]),
							)
						}
					>
						{t('Move to Publisher')}
					</MenuItem>
				)}
				{/* <MenuItem>Action2</MenuItem> */}
			</Menu>
		</Fragment>
	)
}
export default MoreBtnMenu
